import React from 'react';
import './WeatherStatusIcons.scss';

// Icon imports for dark theme
import hazeOfDark from '../../__assets/img/dashboard/dark/ico/ic-haze-of.svg';
import hazeOnDark from '../../__assets/img/dashboard/dark/ico/ic-haze-on.svg';
import fogOfDark from '../../__assets/img/dashboard/dark/ico/ic-fog-of.svg';
import fogOnDark from '../../__assets/img/dashboard/dark/ico/ic-fog-on.svg';
import drizzleOfDark from '../../__assets/img/dashboard/dark/ico/ic-drizzle-of.svg';
import drizzleOnDark from '../../__assets/img/dashboard/dark/ico/ic-drizzle-on.svg';
import rainOfDark from '../../__assets/img/dashboard/dark/ico/ic-rain-of.svg';
import rainOnDark from '../../__assets/img/dashboard/dark/ico/ic-rain-on.svg';
import hailOfDark from '../../__assets/img/dashboard/dark/ico/ic-hail-of.svg';
import hailOnDark from '../../__assets/img/dashboard/dark/ico/ic-hail-on.svg';
import freezingRainOfDark from '../../__assets/img/dashboard/dark/ico/ic-freezing-rain-of.svg';
import freezingRainOnDark from '../../__assets/img/dashboard/dark/ico/ic-freezing-rain-on.svg';
import snowOfDark from '../../__assets/img/dashboard/dark/ico/ic-snow-of.svg';
import snowOnDark from '../../__assets/img/dashboard/dark/ico/ic-snow-on.svg';
import lightningOfDark from '../../__assets/img/dashboard/dark/ico/ic-lightning-of.svg';
import lightningOnDark from '../../__assets/img/dashboard/dark/ico/ic-lightning-on.svg';
import tamperingOfDark from '../../__assets/img/dashboard/dark/ico/ic-tampering-of.svg';
import tamperingOnDark from '../../__assets/img/dashboard/dark/ico/ic-tampering-on.svg';
import cameraOfDark from '../../__assets/img/dashboard/dark/ico/ic-camera-of.svg';
import cameraOnDark from '../../__assets/img/dashboard/dark/ico/ic-camera-on.svg';
import batteryOfDark from '../../__assets/img/dashboard/dark/ico/ic-battery-of.svg';
import batteryOnDark from '../../__assets/img/dashboard/dark/ico/ic-battery-on.svg';

// Icon imports for light theme
import hazeOfLight from '../../__assets/img/dashboard/light/ico/ic-haze-of.svg';
import hazeOnLight from '../../__assets/img/dashboard/light/ico/ic-haze-on.svg';
import fogOfLight from '../../__assets/img/dashboard/light/ico/ic-fog-of.svg';
import fogOnLight from '../../__assets/img/dashboard/light/ico/ic-fog-on.svg';
import drizzleOfLight from '../../__assets/img/dashboard/light/ico/ic-drizzle-of.svg';
import drizzleOnLight from '../../__assets/img/dashboard/light/ico/ic-drizzle-on.svg';
import rainOfLight from '../../__assets/img/dashboard/light/ico/ic-rain-of.svg';
import rainOnLight from '../../__assets/img/dashboard/light/ico/ic-rain-on.svg';
import hailOfLight from '../../__assets/img/dashboard/light/ico/ic-hail-of.svg';
import hailOnLight from '../../__assets/img/dashboard/light/ico/ic-hail-on.svg';
import freezingRainOfLight from '../../__assets/img/dashboard/light/ico/ic-freezing-rain-of.svg';
import freezingRainOnLight from '../../__assets/img/dashboard/light/ico/ic-freezing-rain-on.svg';
import snowOfLight from '../../__assets/img/dashboard/light/ico/ic-snow-of.svg';
import snowOnLight from '../../__assets/img/dashboard/light/ico/ic-snow-on.svg';
import lightningOfLight from '../../__assets/img/dashboard/light/ico/ic-lightning-of.svg';
import lightningOnLight from '../../__assets/img/dashboard/light/ico/ic-lightning-on.svg';
import tamperingOfLight from '../../__assets/img/dashboard/light/ico/ic-tampering-of.svg';
import tamperingOnLight from '../../__assets/img/dashboard/light/ico/ic-tampering-on.svg';
import cameraOfLight from '../../__assets/img/dashboard/light/ico/ic-camera-of.svg';
import cameraOnLight from '../../__assets/img/dashboard/light/ico/ic-camera-on.svg';
import batteryOfLight from '../../__assets/img/dashboard/light/ico/ic-battery-of.svg';
import batteryOnLight from '../../__assets/img/dashboard/light/ico/ic-battery-on.svg';

const iconSets = {
	dark: {
		haze: { off: hazeOfDark, on: hazeOnDark },
		fog: { off: fogOfDark, on: fogOnDark },
		drizzle: { off: drizzleOfDark, on: drizzleOnDark },
		rain: { off: rainOfDark, on: rainOnDark },
		hail: { off: hailOfDark, on: hailOnDark },
		freezingRain: { off: freezingRainOfDark, on: freezingRainOnDark },
		snow: { off: snowOfDark, on: snowOnDark },
		lightning: { off: lightningOfDark, on: lightningOnDark },
		tampering: { off: tamperingOfDark, on: tamperingOnDark },
		camera: { off: cameraOfDark, on: cameraOnDark },
		battery: { off: batteryOfDark, on: batteryOnDark },
	},
	light: {
		haze: { off: hazeOfLight, on: hazeOnLight },
		fog: { off: fogOfLight, on: fogOnLight },
		drizzle: { off: drizzleOfLight, on: drizzleOnLight },
		rain: { off: rainOfLight, on: rainOnLight },
		hail: { off: hailOfLight, on: hailOnLight },
		freezingRain: { off: freezingRainOfLight, on: freezingRainOnLight },
		snow: { off: snowOfLight, on: snowOnLight },
		lightning: { off: lightningOfLight, on: lightningOnLight },
		tampering: { off: tamperingOfLight, on: tamperingOnLight },
		camera: { off: cameraOfLight, on: cameraOnLight },
		battery: { off: batteryOfLight, on: batteryOnLight },
	},
};

const WeatherStatusIcons = ({
	theme = 'dark',
	isHazeActive = false,
	isFogActive = false,
	isDrizzleActive = false,
	isRainActive = false,
	isHailActive = false,
	isFreezingRainActive = false,
	isSnowActive = false,
	isLightningActive = false,
	isTamperingActive = false,
	isCameraActive = false,
	batteryLevel = 'good', // 'good', 'meh', 'bad'
}) => {
	const icons = iconSets[theme] || iconSets.dark;

	const statusItems = [
		{ key: 'haze', label: 'Haze', active: isHazeActive },
		{ key: 'fog', label: 'Fog', active: isFogActive },
		{ key: 'drizzle', label: 'Drizzle', active: isDrizzleActive },
		{ key: 'rain', label: 'Rain', active: isRainActive },
		{ key: 'hail', label: 'Hail', active: isHailActive },
		{ key: 'freezingRain', label: 'Freezing Rain', active: isFreezingRainActive },
		{ key: 'snow', label: 'Snow', active: isSnowActive },
		{ key: 'lightning', label: 'Lightning', active: isLightningActive },
		{ key: 'tampering', label: 'Tampering', active: isTamperingActive },
		{ key: 'camera', label: 'Camera', active: isCameraActive },
	];

	return (
		<div className="weather-status-icons">
			<div className="status-grid">
				{statusItems.map((item) => (
					<div
						key={item.key}
						className={`status-icon ${item.active ? 'active' : ''} ${item.key}`}
						title={item.label}
					>
						<img
							src={item.active ? icons[item.key].on : icons[item.key].off}
							alt={item.label}
						/>
						<span className="status-label">{item.label}</span>
					</div>
				))}
				<div
					className={`status-icon battery-icon ${batteryLevel}`}
					title={`Battery: ${batteryLevel}`}
				>
					<img
						src={batteryLevel !== 'bad' ? icons.battery.on : icons.battery.off}
						alt="Battery"
					/>
					<span className="status-label">Battery</span>
				</div>
			</div>
		</div>
	);
};

export default WeatherStatusIcons;
